import { createPortal } from "react-dom";
import ToggleSwitch from "../../Setting/components/printers/ToggleSwitch";

const AppsModal = ({ open, onClose, apps, onAddClick, onToggle, onDelete, loading }) => {
  if (!open) return null;

  const hasApps = Array.isArray(apps) && apps.length > 0;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="bg-black px-8 py-6 flex items-center justify-between flex-shrink-0">
          <div>
            <h2 className="text-white text-lg font-bold">Manage Apps</h2>
            <p className="text-gray-400 text-xs mt-0.5">
              View apps, change status, and delete
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={onAddClick}
              className="bg-white text-black px-4 py-2 rounded-xl text-xs font-semibold active:scale-[0.98] transition-all duration-200"
            >
              + Add Apps
            </button>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div className="px-8 py-6 overflow-y-auto">
          {!hasApps ? (
            <div className="border border-dashed border-gray-200 rounded-2xl p-6 text-center">
              <div className="text-sm font-semibold text-gray-900">No app added</div>
              <div className="text-xs text-gray-500 mt-1">
                Click "Add Apps" to create your first app.
              </div>
            </div>
          ) : (
            <div className="overflow-x-auto border border-gray-100 rounded-2xl">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-left px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-widest">
                      App
                    </th>
                    <th className="text-left px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-widest">
                      Status
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-widest">
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {apps.map((a) => (
                    <tr key={a._id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <div className="font-semibold text-gray-900">{a.name}</div>
                      </td>
                      <td className="px-4 py-3">
                        <ToggleSwitch
                          checked={!!a.enabled}
                          onChange={() => onToggle?.(a)}
                          labelOn="Enabled"
                          labelOff="Disabled"
                        />
                      </td>
                      <td className="px-4 py-3 text-right">
                        <button
                          type="button"
                          onClick={() => onDelete?.(a)}
                          className="inline-flex items-center justify-center w-9 h-9 rounded-xl border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 transition-colors"
                          title="Delete"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 01 16.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="px-8 py-5 border-t border-gray-100 flex items-center justify-between gap-3 flex-shrink-0">
          <div className="text-xs text-gray-500">{loading ? "Updating..." : ""}</div>
          <button
            type="button"
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white py-2.5 px-5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200"
          >
            Done
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AppsModal;

